export default __webpack_public_path__ + "static/media/arrow-path-rounded-square.b28d0c73.svg";